module.exports = __webpack_public_path__ + "img/hello.ac3b7c35.svg";